<template>
  <div :class="`col ${className}`">
    <div class="title">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['className'],
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseTopBarContent.vue